import { useEffect, useRef, useState } from "react";

const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [variant, setVariant] = useState("default"); // default | banner | button | mukhi | puja
  const pos = useRef({ x: 0, y: 0 });
  const target = useRef({ x: 0, y: 0 });

  useEffect(() => {
    // Enable custom cursor styling globally
    document.body.classList.add("custom-cursor-active");

    const onMove = (e) => {
      target.current = { x: e.clientX, y: e.clientY };
    };

    const detectHover = (e) => {
      const el = e.target;
      if (!el || typeof el.closest !== "function") return;
      if (el.closest("[data-cursor='button'], button, a")) setVariant("button");
      else if (el.closest("[data-cursor='banner']")) setVariant("banner");
      else if (el.closest("[data-cursor='mukhi']")) setVariant("mukhi");
      else if (el.closest("[data-cursor='puja']")) setVariant("puja");
      else setVariant("default");
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", detectHover);

    let raf;
    const animate = () => {
      pos.current.x += (target.current.x - pos.current.x) * 0.2;
      pos.current.y += (target.current.y - pos.current.y) * 0.2;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${target.current.x}px, ${target.current.y}px, 0) translate(-50%, -50%)`;
      }
      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${pos.current.x}px, ${pos.current.y}px, 0) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(animate);
    };
    animate();

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", detectHover);
      document.body.classList.remove("custom-cursor-active");
      cancelAnimationFrame(raf);
    };
  }, []);

  // Variant styles
  const size = {
    default: 12,
    button: 6,
    banner: 18,
    mukhi: 22,
    puja: 24,
  }[variant];

  const ringSize = {
    default: 34,
    button: 60,
    banner: 70,
    mukhi: 80,
    puja: 90,
  }[variant];

  const emoji = {
    default: null,
    button: null,
    banner: "🕉",
    mukhi: null,
    puja: null,
  }[variant];

  return (
    <>
      {/* Center dot (rudraksha bead) */}
      <div
        ref={dotRef}
        className="pointer-events-none fixed left-0 top-0 z-[9999] hidden md:block"
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          background:
            "radial-gradient(circle at 30% 30%, #b46a2a, #6b2f0a 70%, #2a1005)",
          boxShadow: "0 0 8px rgba(139,35,35,0.6)",
          transition: "width 0.2s, height 0.2s",
        }}
      />
      {/* Outer ring — trishul-shape via SVG for mukhi variant */}
      <div
        ref={ringRef}
        className="pointer-events-none fixed left-0 top-0 z-[9998] hidden md:flex items-center justify-center"
        style={{
          width: ringSize,
          height: ringSize,
          borderRadius: "50%",
          border: "1.5px solid rgba(139,35,35,0.5)",
          background: variant === "banner" ? "rgba(212,175,55,0.08)" : "transparent",
          transition: "width 0.25s, height 0.25s, border-color 0.25s",
        }}
      >
        {variant === "mukhi" && (
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2v20M6 6l6-4 6 4M4 8v4M20 8v4M4 12c0 2 1 3 2 4M20 12c0 2-1 3-2 4"
              stroke="#8B2323"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        )}
        {variant === "puja" && (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 3c-2 3-2 5 0 7 2-2 2-4 0-7zM8 12h8M6 15c2 4 10 4 12 0M10 20h4"
              stroke="#8B2323"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        )}
        {emoji && <span className="text-[#8B2323] text-xl">{emoji}</span>}
      </div>
    </>
  );
};

export default CustomCursor;
